import React from 'react'
import { Upload, message, Typography, Button,Spin } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
function UploadMedia(props) {
    const { Title } = Typography
    return (<div className='upload-media-container'><div className='header-section'>
        <Title level={4}>Upload Product Pictures</Title>
        {/* <Button type="primary">Save Changes</Button> */}
    </div>
    <div className='picture-container'>
        <div className='picture'>
            <Upload
                name="avatar1"
                // accept=".jpg,.png"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                beforeUpload={() => { }}
                customRequest={(file) => { 
                    console.log()
                    props?.numberOFpicture(file?.file,'pic1')}}
            >
                 {props?.uploadPhotoMutation?.isLoading == true ? 
                 <Spin></Spin>:
                 props?.selectedProduct?.pic1 != undefined ? <img src={props?.selectedProduct?.pic1} alt="avatar" style={{ width: '100%' }} /> :
                <span className='upload-btn-content'>
                    <PlusOutlined />
                    left
                </span>}
            </Upload>
        </div>
        <div className='picture'>
            <Upload
                name="avatar2"
                listType="picture-card"
                accept=".jpg,.png"
                className="avatar-uploader"
                showUploadList={false}
                beforeUpload={() => { }}
                customRequest={(file) => { 
                    console.log(file?.file?.originFileObj)
                    props?.numberOFpicture(file?.file,'pic2')}}
            >
                  {props?.selectedProduct?.pic2 != undefined ? <img src={props?.selectedProduct?.pic2} alt="avatar" style={{ width: '100%' }} /> :
                <span className='upload-btn-content'>
                    <PlusOutlined />
                    Top
                </span>}
            </Upload>
            <Upload
                name="avatar3"
                listType="picture-card"
                accept=".jpg,.png"
                className="avatar-uploader"
                showUploadList={false}
                beforeUpload={() => { }}
                customRequest={(file) => { 
                    console.log(file?.file?.originFileObj)
                    props?.numberOFpicture(file?.file,'pic3')}}
            >
                  {props?.selectedProduct?.pic3 != undefined ? <img src={props?.selectedProduct?.pic3} alt="avatar" style={{ width: '100%' }} /> :
                <span className='upload-btn-content'>
                    <PlusOutlined />
                    Front
                </span>}
            </Upload>
            <Upload
                name="avatar4"
                listType="picture-card"
                accept=".jpg,.png"
                className="avatar-uploader"
                showUploadList={false}
                beforeUpload={() => { }}
                customRequest={(file) => { 
                    console.log(file?.file?.originFileObj)
                    props?.numberOFpicture(file?.file,'pic4')}}
            >
                 {props?.selectedProduct?.pic4 != undefined ? <img src={props?.selectedProduct?.pic4} alt="avatar" style={{ width: '100%' }} /> :
                <span className='upload-btn-content'>
                    <PlusOutlined />
                    Bottom
                </span>
}
            </Upload>
            </div>
            <div className='picture'>
            <Upload
                name="avatar5"
                listType="picture-card"
                accept=".jpg,.png"
                className="avatar-uploader"
                showUploadList={false}
                beforeUpload={() => { }}
                customRequest={(file) => {
                    props?.numberOFpicture(file?.file,'pic5')}}
            >
                {props?.selectedProduct?.pic5 != undefined ? <img src={props?.selectedProduct?.pic5} alt="avatar" style={{ width: '100%' }} /> :
                <span className='upload-btn-content'>
                    <PlusOutlined />
                    Back
                </span>
}
            </Upload>
            
        </div>
        <div className='picture'>
            <Upload
                name="avatar6"
                listType="picture-card"
                accept=".jpg,.png"
                className="avatar-uploader"
                showUploadList={false}
                action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                beforeUpload={() => { }}
                customRequest={(file) => { 
                    props?.numberOFpicture(file?.file,'pic6')}}
            >
               {props?.selectedProduct?.pic6 != undefined ? <><img src={props?.selectedProduct?.pic6} alt="avatar" style={{ width: '100%' }} /></> :
                <span className='upload-btn-content'>
                    <PlusOutlined />
                    Right
                </span>}
            </Upload>
        </div>
        </div>

    </div>
    )
}

export default UploadMedia
